/**
 * Motivos de perda do CRM (#6419). A lista vem da tabela motivos_perda, que também
 * diz quais motivos põem a negociação na lista de Remarketing e depois de quantos dias.
 *
 * O valor gravado em negociacoes.motivo_perda continua sendo o texto do motivo:
 * relatórios e o Analytics agrupam por ele.
 */

export interface MotivoPerda {
  motivo: string;
  ordem: number;
  ativo: boolean;
  vai_para_remarketing: boolean;
  esperar_dias: number;
  /** Sugestão de mensagem. {nome} = primeiro nome do cliente, {atendente} = de quem envia. */
  roteiro: string | null;
}

const m = (motivo: string, ordem: number, esperar_dias = 0): MotivoPerda => ({
  motivo, ordem, ativo: true, vai_para_remarketing: esperar_dias > 0, esperar_dias, roteiro: null,
});

/**
 * Reserva para quando a tabela não carrega (migration ainda não aplicada, rede).
 * Igual à semente da migration 20261030125000, sem os roteiros.
 */
export const MOTIVOS_PERDA_PADRAO: MotivoPerda[] = [
  m('Possui energia solar', 10),
  m('Consumo abaixo de 300 kWh', 20),
  m('Região não atendida', 30),
  m('Sem retorno', 40, 15),
  m('Pediu para falar depois', 45, 30),
  m('Acha que é golpe', 50, 7),
  m('Não tem interesse', 60, 60),
  m('Fechou com outra empresa', 70, 180),
  m('Erro no cadastro', 80),
  m('Outros', 90),
];

/** Os motivos que aparecem para escolha, na ordem da lista. */
export function motivosParaEscolha(lista: MotivoPerda[]): MotivoPerda[] {
  return lista.filter(x => x.ativo).sort((a, b) => a.ordem - b.ordem);
}

/** Data a partir da qual a BDR retoma o contato, ou null se o motivo não vai para o remarketing. */
export function reabordarEm(motivo: MotivoPerda | undefined, perdidoEm: Date = new Date()): Date | null {
  if (!motivo?.vai_para_remarketing) return null;
  return new Date(perdidoEm.getTime() + motivo.esperar_dias * 86_400_000);
}
